module.exports = __webpack_public_path__ + "img/farzana-christopher-104.2dc11b0a.jpg";